import { Box, Card, Divider, styled, Typography } from '@mui/material';
import React from 'react';
import useGetUserWallet from '../../../../hooks/useGetUserWallet';
import { fCurrency } from '../../../../utils/formatNumber';

const CuztomBox = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  gap: '10px',
  marginTop: '15px'
}));

function UserWallet({ userId }) {
  const { userWallet } = useGetUserWallet(userId);

  return (
    <Card sx={{ padding: '15px' }}>
      <Typography variant="h5">Wallet del usuario</Typography>
      <Divider />
      <CuztomBox>
        <Typography variant="subtitle1">Saldo de servicios:</Typography>
        <Typography fontWeight="600">
          {userWallet?.saldoServicio ? fCurrency(userWallet?.saldoServicio) : fCurrency(0)}
        </Typography>
      </CuztomBox>
      <CuztomBox>
        <Typography variant="subtitle1">Saldo de paqueteria:</Typography>
        <Typography fontWeight="600">
          {userWallet?.saldoPaqueteria ? fCurrency(userWallet?.saldoPaqueteria) : fCurrency(0)}
        </Typography>
      </CuztomBox>
      <CuztomBox>
        <Typography variant="subtitle1">Saldo de recarga:</Typography>
        <Typography fontWeight="600">
          {userWallet?.saldoRecarga ? fCurrency(userWallet?.saldoRecarga) : fCurrency(0)}
        </Typography>
      </CuztomBox>
    </Card>
  );
}

export default UserWallet;
